import { render, staticRenderFns } from "./Purchase_summary.vue?vue&type=template&id=152f842f&scoped=true&"
import script from "./Purchase_summary.vue?vue&type=script&lang=js&"
export * from "./Purchase_summary.vue?vue&type=script&lang=js&"
import style0 from "./Purchase_summary.vue?vue&type=style&index=0&id=152f842f&prod&lang=css&"
import style1 from "./Purchase_summary.vue?vue&type=style&index=1&id=152f842f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152f842f",
  null
  
)

export default component.exports